import React, { useState } from "react";

const LayoutTab = ({ handleLayoutChange, selectedLayout,updateFacebookShareButtonTabData,facebookShareButtonTabData }) => {
    const [sourceType, setSourceType] = useState(facebookShareButtonTabData.source_type);
    const [sourceTypeDropdownOpen, setSourceTypeDropdownOpen] = useState(false);
    const [customUrl, setShowCustomUrl] = useState(facebookShareButtonTabData.custom_url);
    const [layoutType, setLayoutType] = useState(facebookShareButtonTabData.layout_type);
    const [layoutTypeDropdownOpen, setLayoutTypeDropdownOpen] = useState(false);
    const [activeSizeType, setActiveSizeType] = useState(facebookShareButtonTabData.size_type);

    // Handlers Source Type Change
    const handleSourceTypeChange = (type) => {
        setSourceType(type);
        updateFacebookShareButtonTabData("source_type", type);
        setSourceTypeDropdownOpen(false);
    };

    // Handlers Show Custom Url Change
    const handleShowCustomUrlChange = (e) => {
        const value = e.target.value;
        setShowCustomUrl(value);
        updateFacebookShareButtonTabData("custom_url", value); 
    };

   // Handlers Layout Type Change
    const handleLayoutTypeChange = (type) => {
        setLayoutType(type);
        updateFacebookShareButtonTabData("layout_type", type);
        setLayoutTypeDropdownOpen(false);
    };
    
    // Handle Size Type change
    const handleActiveSizeTypeChange = (event) => {
        setActiveSizeType(event.target.value);
        updateFacebookShareButtonTabData("size_type", event.target.value);
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            <span>Source</span>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Source</span>
                    <div className="color-pikr-box" onClick={() => setSourceTypeDropdownOpen(!sourceTypeDropdownOpen)}>
                        <em>{sourceType}</em>
                        {sourceTypeDropdownOpen && (
                            <ul className="dropdown-list">
                                {["Current Page","Custom URL"].map((type) => (
                                    <li key={type} onClick={() => handleSourceTypeChange(type)}>
                                        {type}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                {sourceType === "Custom URL" && (
                <>
                    <div className="side-baar-box-header">
                        <div className="box-header-row input-fild">
                            <label>Custom Url</label>
                            <input type="text" value={customUrl} onChange={handleShowCustomUrlChange}placeholder="" />
                        </div>
                    </div>
                </> 
                )}
            </div>

            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Layout</span>
                    <div className="color-pikr-box" onClick={() => setLayoutTypeDropdownOpen(!layoutTypeDropdownOpen)}>
                        <em>{layoutType}</em>
                        {layoutTypeDropdownOpen && (
                            <ul className="dropdown-list">
                                {["Box count","Button count","Button"].map((type) => (
                                    <li key={type} onClick={() => handleLayoutTypeChange(type)}>
                                        {type}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                <div className="box-header-row">
                    <p>Size</p>
                    <div className="left-cnater-right-button">
                        <label className="card-radio-btn">
                            <input type="radio" name="size_type" className="card-input-element d-none" value="small" onChange={handleActiveSizeTypeChange} checked={activeSizeType === "small"} />
                            <div className="card card-body">
                                <div className="content_sub">Small</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="size_type" className="card-input-element d-none" value="large" onChange={handleActiveSizeTypeChange} checked={activeSizeType === "large"} />
                            <div className="card card-body">
                                <div className="content_sub">Large</div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LayoutTab;